export enum AssetParser {

    MODEL = "model",
    BLOCKSTATE = "blockstate",
    META = "meta",
    NBT = "nbt",
    IMAGE = "image",
    LIST = "list",
    JSON = "json",

}